import { FileUpload } from "primereact/fileupload";
import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import * as Fa from "react-icons/fa";
import { createAPIEndpointStockNormBulkUpload, EndpointStockNormBulkUpload } from "../../Services/StockNormBulkUpload/StockNormBulkUploadService";
import storage from "../../Services/Storage";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

const StockNormBulkUpload = () => {

    const [quarterData, setQuarterData] = useState();
    const [dateRangeData, setDateRangeData] = useState();
    const [showUploadButton, setShowUploadButton] = useState();
    const auth = storage.getLocal("user");
    const [selectedQuarter, setSelectedQuarter] = useState(null);



    const UploadCSV = async (payload) => {
        try {
            const res = await createAPIEndpointStockNormBulkUpload().post(`${EndpointStockNormBulkUpload.UploadCSV}`, payload);
            console.log("res ",res);

        } catch (error) {
            console.log("error ", error);
        }

    };

    const PopulateQuarter = async () => {
        try {
            const res = await createAPIEndpointStockNormBulkUpload().get(`${EndpointStockNormBulkUpload.PopulateQuarter}`);
            setQuarterData(res.data.Data);
            console.log("res.data data ", res.data.Data);
        } catch (error) {
            console.log("error ", error);
        }

    };

    const checkValidity = () => {
        const MNTH = dateRangeData[0]?.MNTH;
        const START_DATE = dateRangeData[0]?.START_DATE;
        const END_DATE = dateRangeData[0]?.END_DATE;

        const today = new Date();

        const currentMonth = today.getMonth() + 1;

        const currentDay = today.getDate();
        if (currentMonth === MNTH) {

            if (currentDay >= START_DATE && currentDay <= END_DATE) {
                setShowUploadButton(true);
            }
        }
        setShowUploadButton(false);
    };

    const GetDateRange = async () => {
        try {
            const res = await createAPIEndpointStockNormBulkUpload().get(`${EndpointStockNormBulkUpload.GetDateRange}?CompId=${auth.CompId}`);
            console.log("GetDateRange response ", res.data.Data);
            setDateRangeData(res.data.Data);
            checkValidity();
        } catch (error) {
            console.log("error ", error);
        }

    };
    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.value);
    };

    const handleFileUpload = (e) => {
        const file = e.files;

        file.forEach((file) => {
            if (file.type !== "text/csv") {
                toast.error("Only  CSV (.csv) files are supported.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;
            }

            const reader = new FileReader();

            reader.onload = (e) => {
                const arrayBuffer = e.target.result;
                const workbook = XLSX.read(arrayBuffer, { type: "array" });

                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const data = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });
                const headers = data[0];
                const rows = data.slice(1).filter(row => row.some(cell => cell !== null));

                const convertExcelDate = (dateNum) => {
                    const baseDate = new Date(1900, 0, 1);
                    const date = new Date(baseDate.getTime() + (dateNum - 2) * 86400000);
                    return date;
                };

                const formatDate = (date) => {
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const year = date.getFullYear();
                    return `${day}/${month}/${year}`;
                };

                const result = rows.map((row) => {
                    let obj = {};
                    row.forEach((cell, index) => {
                        const header = headers[index];
                        if (header?.includes("Date") && !isNaN(cell)) {
                            const dateObj = convertExcelDate(cell);
                            obj[header] = formatDate(dateObj);
                        } else {
                            obj[header] = cell;
                        }
                    });
                    return obj;
                });

                console.log(file.name.split(".").pop());
                const payload = {
                    compId: auth.CompId,
                    qtrId: quarterData?.QTR_ID,
                    fileExtension: file.name.split(".").pop(),
                    objExcel: result.map(row => ({
                        base_Product_Code: String(row["Base Product Code"]),
                        final_Stock_Norm: String(row["Final Stock Norm"])
                    }))
                };

                UploadCSV(payload);
            };

            reader.readAsArrayBuffer(file);
        });
    };
    const downloadFile = () => {
        const headers = "Base Product Code,Final Stock Norm(Ltrs)\n";
        let date = new Date();
        let day = date.getDate();
        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let exactmonths = months[date.getMonth()];
        let year = date.getFullYear();
        let uniqueNo = Math.floor(Math.random() * 10000);
        let filename = `Stock_Norm_Template${day}${exactmonths}${year}_${uniqueNo}`;

        const blob = new Blob([headers], { type: "text/csv" });
        
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    };

    useEffect(() => {
        PopulateQuarter();
        GetDateRange();
    }, []);

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Stock Norm Bulk Upload</h3>
                    </div>
                    {/* <div className="col-lg-3 col-md-3 col-sm-12 float-end dropPos">
                        <Dropdown />
                    </div> */}
                    <div className="col-lg-6 ol-md-6 col-sm-12">
                        <div className="text-end">
                            <button type="submit" className="btn btn-primary" onClick={downloadFile}>Download Template <Fa.FaDownload className='ms-2' /></button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className='row'>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block">
                                <label className="form-label">Quarter</label>
                                <Dropdown
                                    value={selectedQuarter}
                                    options={quarterData}
                                    onChange={(e) => handleQuarterChange(e)}
                                    optionLabel="QTR_NAME"
                                    optionValue="QTR_ID"
                                    placeholder="Select a Quarter"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row d-flex justify-content-end align-items-end'>
                        <div className="col-lg-8 col-md-6 col-sm-12">
                            <div className="UploadSection">
                                <FileUpload accept=".csv" customUpload
                                    single="true"
                                    uploadHandler={handleFileUpload}
                                    disabled={!showUploadButton}
                                    emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>} 
                                />
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12'>
                            <div className="text-end">
                                <img src={require("../../Assets/Images/File_Upload.png")} className="File_Upload_Img" />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default StockNormBulkUpload;